<template>
  <div class="tenant_option_info_area" id="tenant_option_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="passwordEnableFlagLabel"
        :valueLabel="passwordEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        v-if="showInitLoginPasswordLabel"
        :titleLabel="initLoginPasswordLabel"
        :valueLabel="corporation.initLoginPassword"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutEnableFlagLabel"
        :valueLabel="autoLogoutEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutSecondLabel"
        :valueLabel="autoLogoutSecond"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="ratingQuarityEnableFlagLabel"
        :valueLabel="ratingQuarityEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="pushNotificationEnableFlagLabel"
        :valueLabel="pushNotificationEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="spEnableFlagLabel"
        :valueLabel="spEnableFlag"
      ></valueLabelSection>

      <valueLabelSection
        :titleLabel="contactsEnableFlagLabel"
        :valueLabel="contactsEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="remarksLabel"
        :valueLabel="corporation.remarks"
      ></valueLabelSection>
    </div>
    <div class="edit_area_half">
      <callAppListSection
        :titleLabel="linkedApplication"
        :callAppList="corporation.callAppList"
      ></callAppListSection>
    </div>
  </div>
</template>

<script>
import valueLabelSection from './valueLabelSection.vue'
import callAppListSection from './callAppListSection.vue'

export default {
  props: {
    showInitLoginPasswordLabel: Boolean
  },
  data() {
    return {
      passwordEnableFlagLabel: 'アプリパスワードの使用有無',
      initLoginPasswordLabel: 'アプリ初期パスワード',
      autoLogoutEnableFlagLabel: 'アプリ自動ログアウトの使用有無',
      autoLogoutSecondLabel: '自動ログアウト時間',
      ratingQuarityEnableFlagLabel: '評価管理機能の使用有無',
      pushNotificationEnableFlagLabel: 'push通知機能の使用有無',
      spEnableFlagLabel: 'サイレントpush通知機能の使用有無',
      contactsEnableFlagLabel: '標準電話帳連携機能の使用有無',
      remarksLabel: '備考',
      passwordLabel: '管理者パスワード',
      initialValue: 3600,
      linkedApplication: '連携アプリ'
    }
  },
  components: {
    valueLabelSection,
    callAppListSection
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    passwordEnableFlag() {
      return this.$store.state.corporations.corporation.passwordEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    autoLogoutEnableFlag() {
      return this.$store.state.corporations.corporation.autoLogoutEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    ratingQuarityEnableFlag() {
      return this.$store.state.corporations.corporation.ratingQuarityEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    pushNotificationEnableFlag() {
      return this.$store.state.corporations.corporation.pushNotificationEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    spEnableFlag() {
      return this.$store.state.corporations.corporation.spEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    contactsEnableFlag() {
      return this.$store.state.corporations.corporation.contactsEnableFlag.toString() ===
        'true'
        ? 'ON'
        : 'OFF'
    },
    autoLogoutSecond() {
      return (
        parseInt(
          this.$store.state.corporations.corporation.autoLogoutSecond / 3600
        ) + '時間'
      )
    }
  }
}
</script>

<style scoped>
.detail_content {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantOptionInfo.vue